<template>
  <path
    d="M20 11.0002H6.82998L9.70998 8.12016C10.1 7.73016 10.1 7.10016 9.70998 6.71016C9.31998 6.32016 8.68998 6.32016 8.29998 6.71016L3.70998 11.3002C3.31998 11.6902 3.31998 12.3202 3.70998 12.7102L8.29998 17.3002C8.68998 17.6902 9.31998 17.6902 9.70998 17.3002C10.1 16.9102 10.1 16.2802 9.70998 15.8902L6.82998 13.0002H20C20.55 13.0002 21 12.5502 21 12.0002C21 11.4502 20.55 11.0002 20 11.0002Z"
  />
</template>
